{
  "name": "valamar-vrc-fe",
  "version": "4.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration=local",
    "build": "ng build --configuration development",
    "prodtest": "ng build --configuration prodtest",
    "prodlocal": "ng build --configuration local",
    "prod": "(npm run prebuildprod1 || npm run prebuildprod) && node indexedit.js && ng build --configuration production",
    "dev": "(npm run prebuilddev1 || npm run prebuilddev) && node indexedit.js && ng build --configuration development",
    "staging": "(npm run prebuildtest1 || npm run prebuildtest) && node indexedit.js && ng build --configuration staging",
    "test02": "(npm run prebuildtest1 || npm run prebuildtest) && node indexedit.js && ng build --configuration test02",
    "prebuilddev": "copy /Y src\\manifest.dev.webmanifest src\\manifest.webmanifest",
    "prebuilddev1": "cp src/manifest.dev.webmanifest src/manifest.webmanifest",
    "prebuildtest": "copy /Y src\\manifest.test.webmanifest src\\manifest.webmanifest",
    "prebuildtest1": "cp src/manifest.test.webmanifest src/manifest.webmanifest",
    "prebuildprod": "copy /Y src\\manifest.prod.webmanifest src\\manifest.webmanifest",
    "prebuildprod1": "cp src/manifest.prod.webmanifest src/manifest.webmanifest",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@angular/service-worker": "^22.1.6",
    "@azure/msal-angular": "^6.2.1",
    "@azure/msal-browser": "^5.22.0",
    "@types/luxon": "^3.7.1",
    "@valamar/val-date-input": "^1.0.10",
    "@valamar/val-drawer": "^1.0.10",
    "@valamar/val-modal": "^1.0.10",
    "@valamar/val-table": "^1.0.10",
    "@valamar/val-toast": "^1.0.10",
    "@valamar/val-tooltip": "^1.0.10",
    "@valamar/val-validation-error": "^1.0.10",
    "bootstrap": "^5.3.7",
    "luxon": "^3.7.2",
    "ngx-infinite-scroll": "^22.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.6",
    "@angular/localize": "^22.1.6",
    "@types/jasmine": "~5.1.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.2.0",
    "jsdom": "^30.1.3",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  }
}
